import { http } from '@/lib/http';
import { PlatformLogical } from '@/types/ext_assessment';

export interface Assessment {
  id: string | number;
  name?: string;
  title?: string;
  link?: string;
}

export interface AssessmentsResponse {
  tests: Assessment[];
  meta: {
    total_count: number;
  };
  error?: string;
  details?: string;
}

const PLATFORM_ENDPOINTS = {
  hackerrank: 'hacker_rank',
  hackerearth: 'hacker_earth',
  criteriacorp: 'criteria_corp',
  hireflix: 'hireflix',
  codeinterview: 'code_interview',
};

export const getAssessments = async (
  platform: PlatformLogical
): Promise<AssessmentsResponse> => {
  const endpoint = PLATFORM_ENDPOINTS[platform];
  let apiPath = 'list_assessments';

  if (platform === 'criteriacorp') {
    apiPath = 'list_packages';
  } else if (platform === 'hireflix') {
    apiPath = 'list_positions';
  }

  const response = await http.get(`/${endpoint}/${apiPath}`);

  // Handle different response structure for criteriacorp
  if (platform === 'criteriacorp') {
    const { packages, meta } = response.data || response;
    return {
      tests: packages || [],
      meta: meta || { total_count: 0 },
    };
  }

  // Handle different response structure for hireflix
  if (platform === 'hireflix') {
    const { positions, meta } = response.data || response;
    return {
      tests: positions || [],
      meta: meta || { total_count: 0 },
    };
  }

  // @ts-expect-error Response shape varies by platform
  return response;
};
